module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3LjU0IDYuODEiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojY2YxZjJlO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTcuNTQsMy40LDUsNi44MUgzLjQxTDUuOTIsMy40LDMuNDEsMEg1Wm0tMy40MSwwTDEuNTYsNi44MUgwTDIuNTEsMy40LDAsMEgxLjU2WiIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newImages/right-red-arrow.svg
// module id = 157
// module chunks = 4